<template lang="pug">
app-main-content-layout(title='Add New Static Page')
  template(#actions)
    el-button(
      type="primary"
      @click="createStaticPage"
      :loading="loading"
      color='#1EBEAF'
      size="large"
    ) Create Static Page

  div
    .row
      .col-12
        el-card(class="box-card" style="margin-bottom: 20px;")
          template(#header)
            .card-header
              span New Static Page

          el-form(:model="newStaticPage" label-position="top")
            .row
              .col-md-6
                el-form-item(label="Title" required)
                  el-input(v-model="newStaticPage.title" placeholder="Enter page title")

              .col-md-6
                el-form-item(label="Slug" required)
                  el-input(v-model="newStaticPage.slug" placeholder="Enter page slug")

</template>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>

<script>
import { reactive, defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import shared from '../shared';
import { mutateStaticPage } from '@/graphs/definitions';

export default defineComponent({
  name: 'ManageContent_Media_AddStaticPage',
  setup() {
    const { makeGraphRequest, getAuthToken, loading } = shared();
    const router = useRouter();

    const newStaticPage = reactive({
      title: '',
      slug: '',
    });

    async function createStaticPage() {
      console.log('createStaticPage called'); // Debug log
      console.log('newStaticPage:', newStaticPage); // Debug log
      
      try {
        loading.value = true;

        const inputData = { ...newStaticPage, id: null };
        console.log('Input data:', inputData); // Debug log

        const response = await makeGraphRequest(
          'mutation',
          mutateStaticPage,
          { input: inputData },
          getAuthToken(),
        );

        console.log('Response:', response); // Debug log

        if (response && response.data && response.data.mutateStaticPage) {
          console.log('Success! Redirecting...'); // Debug log
          // Success - redirect to the static pages list
          router.push('/manage-content/media/static-pages');
        } else {
          console.log('No data in response or mutation failed'); // Debug log
        }
      } catch (err) {
        console.error('Error creating static page:', err);
        // Show error message (you might want to add a toast notification here)
      } finally {
        loading.value = false;
      }
    }

    return {
      newStaticPage,
      loading,
      createStaticPage,
    };
  },
});
</script>
